import api from '../nestix/services/api';
import { getOrgLocale } from './locale';

let cache = null;
let cacheOrg = null;

// Drop the cached letterhead when Settings (logo / company details) change, so prints pick up the new logo without a reload.
if (typeof window !== 'undefined') {
  window.addEventListener('company-settings-updated', () => { cache = null; });
}

// Company letterhead details from ERP Settings (logo, name, ABN, address, contact), falling back to the organisation.
export async function loadCompanyProfile(force = false) {
  const org = getOrgLocale();
  // getOrgLocale() returns a new object whenever the active organisation is (re)loaded, so a switch of org refreshes the cache.
  if (cache && !force && cacheOrg === org) { return cache; }
  cacheOrg = org;
  let s = {};
  try { s = (await api.get('/settings')).data || {}; } catch (e) { s = {}; }
  const addr2 = [s.suburb, [s.state, s.postcode].filter(Boolean).join(' ')].filter(Boolean).join(' ');
  cache = {
    logo: s.company_logo_url || '',
    name: s.company_name || org.name || '',
    abn: s.company_abn || '',
    addressLines: s.street_address ? [s.street_address, addr2].filter(Boolean) : (org.address ? [org.address] : []),
    phone: s.company_phone || '',
    email: s.company_email || '',
    website: s.company_website || '',
  };
  return cache;
}

export const getCompanyProfile = () => cache;
